import FileDownload from "js-file-download";
import EDHttp from "../utils/EDHttp";

export default {
  saveSurvey: function (id, survey) {
    return new Promise((resolve, reject) => {
      EDHttp.put(`/api/domain/survey/${id}`, { survey })
        .then(
          (result) => {
            if (result && !result.data.error) resolve(result.data.data);
            else reject("Error");
          },
          (error) => reject(error),
        )
        .catch((error) => reject(error));
    });
  },
  deleteSurvey: function (id) {
    return new Promise((resolve, reject) => {
      return new Promise((resolve, reject) => {
        EDHttp.delete(`/api/domain/survey/${id}`)
          .then(
            (result) => {
              if (result && !result.data.error) resolve(result.data.data);
              else reject("Error");
            },
            (error) => reject(error),
          )
          .catch((error) => reject(error));
      });
    });
  },
  setString: function (id, stringId, stringText) {
    return new Promise((resolve, reject) => {
      EDHttp.put(`/api/domain/string/${id}`, {
        string_id: stringId,
        string_text: stringText,
      })
        .then(
          (result) => {
            if (result && !result.data.error) resolve(result.data.data);
            else reject("Error");
          },
          (error) => reject(error),
        )
        .catch((error) => reject(error));
    });
  },
  load: function (page = 0, search) {
    return new Promise((resolve, reject) => {
      EDHttp.get(`/api/domain?page=${page}&search=${search}`)
        .then(
          (result) => {
            if (result && !result.data.error) resolve(result.data.data);
            else reject("Error");
          },
          (error) => reject(error),
        )
        .catch((error) => reject(error));
    });
  },
  async all() {
    try {
      const { data: result } = await EDHttp.get("/api/domain");
      return result.data;
    } catch (error) {
      throw error.response.data.message;
    }
  },
  get: function (id) {
    return new Promise((resolve, reject) => {
      EDHttp.get(`/api/domain/single/${id}`)
        .then(
          (result) => {
            if (result && !result.data.error) resolve(result.data.data);
            else reject("Error");
          },
          (error) => reject(error),
        )
        .catch((error) => reject(error));
    });
  },
  async add(settings) {
    try {
      const { data: result } = await EDHttp.post(`/api/domain`, {
        ...settings,
      });
      return result.data;
    } catch (error) {
      throw error.response.data.message;
    }
  },
  async update(id, settings) {
    try {
      const { data: result } = await EDHttp.put(`/api/domain/update/${id}`, {
        ...settings,
      });
      return result.data;
    } catch (error) {
      throw error.response.data.message;
    }
  },
  delete: function (id) {
    return new Promise((resolve, reject) => {
      EDHttp.delete(`/api/domain/delete/${id}`)
        .then(
          (result) => {
            if (result && !result.data.error) resolve(result.data.data);
            else reject("Error");
          },
          (error) => reject(error),
        )
        .catch((error) => reject(error));
    });
  },
  uploadDocument: function (formData) {
    return new Promise((resolve, reject) => {
      EDHttp.uploadFormData(`/api/domain/documents/upload`, formData)
        .then(
          (result) => {
            if (result && !result.data.error) resolve(result.data.data);
            else reject("Error");
          },
          (error) => reject(error),
        )
        .catch((error) => reject(error));
    });
  },
  downloadSurvey: function (id, domain) {
    return new Promise((resolve, reject) => {
      EDHttp.get(`/api/domain/survey/${id}`)
        .then(
          (response) => {
            if (response.status == 200) {
              let date = new Date();
              FileDownload(
                response.data,
                `${domain}-survey-${date.getMonth() + 1}-${date.getDate()}-${date.getFullYear()}.csv`,
              );
              resolve(true);
            } else reject("Error");
          },
          (error) => reject(error),
        )
        .catch((error) => reject(error));
    });
  },
  getEmployers: async function () {
    try {
      const { data: result } = await EDHttp.get("/api/domain");
      return result.data;
    } catch (error) {
      throw error.response.data.message;
    }
  },
  updateEntity: async (domainId, entity) => {
    try {
      const { data: result } = await EDHttp.put(
        `/api/domain/update-entity/${domainId}`,
        entity,
      );
      return result.data;
    } catch (error) {
      throw error.response.data.message;
    }
  },
  updateSplashPage: async (domainId, data) => {
    try {
      const { data: result } = await EDHttp.put(
        `/api/domain/update-splash-page/${domainId}`,
        data,
      );
      return result.data;
    } catch (error) {
      throw error.response.data.message;
    }
  },
  async getSsoConfigurations(domainId, page) {
    try {
      const { data: result } = await EDHttp.get(
        `/api/domain/sso-configurations/${domainId}?page=${page}`,
      );
      return result.data;
    } catch (error) {
      throw error.response.data.message;
    }
  },
  async updateSsoConfiguration(id, payload) {
    try {
      const { data: result } = await EDHttp.put(
        `/api/domain/sso-configuration/${id}`,
        payload,
      );
      return result.data;
    } catch (error) {
      const rawErrorMessage =
        error.response?.data?.errors || error.response?.data?.message;
      const errorMessage = Array.isArray(rawErrorMessage)
        ? rawErrorMessage.join(", ")
        : rawErrorMessage;
      throw errorMessage;
    }
  },
  async updateAllSsoConfigurationStatus(domainId, payload) {
    try {
      const { data: result } = await EDHttp.patch(
        `/api/domain/sso-configurations/${domainId}/status`,
        payload,
      );
      return result.data;
    } catch (error) {
      const rawErrorMessage =
        error.response?.data?.errors || error.response?.data?.message;
      const errorMessage = Array.isArray(rawErrorMessage)
        ? rawErrorMessage.join(", ")
        : rawErrorMessage;
      throw errorMessage;
    }
  },
  async createSsoConfiguration(payload) {
    try {
      const { data: result } = await EDHttp.post(
        `/api/domain/sso-configuration`,
        payload,
      );
      return result.data;
    } catch (error) {
      const rawErrorMessage =
        error.response?.data?.errors || error.response?.data?.message;
      const errorMessage = Array.isArray(rawErrorMessage)
        ? rawErrorMessage.join(", ")
        : rawErrorMessage;
      throw errorMessage;
    }
  },
};
